import EFPauseBig from '@/components/UI/svg/Icons/EFPauseBig';
import EFPlayBig from '@/components/UI/svg/Icons/EFPlayBig';
import { useGlobal } from '@/utils/useGlobal';
import { ControlBar, CurrentTimeDisplay, Player, PlayToggle, ReplayControl, TimeDivider, VolumeMenuButton } from 'video-react';
import 'video-react/dist/video-react.css';
import css from './index.module.scss';
const configs = {
    bgColor: '#000',
    navColor: '#fff',
    listColor: '#fff',
    src: '/video/aboutus.mp4',
    height: '720px',
    autoPlay: false,
    hideControl: false,
    disableDefaultControls: false,
    isShowTip: false,
    fullScreen: false,
};
export default function VideoModule({ config }: any) {
    const { useState, useEffect } = useGlobal();
    const [playerBox, setPlayerBox] = useState({});
    const [status, setStatus] = useState('pause');
    const [inZone, setInZone] = useState(false);
    const configTypes = { ...configs, ...config };

    const play = () => {
        playerBox.video.video.addEventListener('ended', () => {
            setStatus('pause');
        });
        playerBox.play();
        setStatus('play');
    };
    const pause = () => {
        playerBox.pause();
        setStatus('pause');
    };
    const inVideo = () => {
        setInZone(true);
    };
    const outVideo = () => {
        setInZone(false);
    };

    return (
        <div className={`${css.VideoModule} videoModules`} style={{ background: configTypes.bgColor }}>
            <div
                className="video-wrap"
                onMouseEnter={inVideo}
                onMouseLeave={outVideo}
                style={{
                    height: configTypes.fullScreen ? '1080px' : '720px',
                    width: configTypes.fullScreen ? '100%' : '1280px',
                }}
            >
                <Player
                    className="videos"
                    src={configTypes.src}
                    ref={(c: any) => {
                        setPlayerBox(c);
                        return playerBox;
                    }}
                    playsInline
                    fluid={true}
                    autoPlay={configTypes.autoPlay}
                >
                    {/* <source src="/video/op.mp4"/> */}

                    <ControlBar disableDefaultControls={configTypes.disableDefaultControls} className={configTypes.hideControl ? 'hideControl' : ''}>
                        <ReplayControl seconds={10} order={1.1} />
                        <PlayToggle />
                        <CurrentTimeDisplay order={4.1} />
                        <TimeDivider order={4.2} />
                        <VolumeMenuButton vertical rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
                    </ControlBar>
                </Player>
                <div className="videoButton" style={{ display: status === 'play' ? 'none' : 'block' }} onClick={play}>
                    <EFPlayBig />
                </div>
                <div className="videoButton" style={{ display: status === 'play' && inZone ? 'block' : 'none' }} onClick={pause}>
                    <EFPauseBig />
                </div>
            </div>
        </div>
    );
}
